<script>
  const img_step01 = "/assets_default/images/service/loan/guide/fixed-repayment/service_loan_fixed-repayment_step_01.webp"
  const img_step02 = "/assets_default/images/service/loan/guide/fixed-repayment/service_loan_fixed-repayment_step_02.webp"
  const img_step03 = "/assets_default/images/service/loan/guide/fixed-repayment/service_loan_fixed-repayment_step_03.webp"
</script>

  <page-header text="定額返済"></page-header>
  <keyvisual-content
    title="毎月の返済額と返済日を<br>自由に設定できる"
    image="/assets_default/images/service/loan/guide/fixed-repayment/service_loan_fixed-repayment_kv.webp"
  >
  </keyvisual-content>
  <section class="owd-section spacing:bottom:64">
    <p class="owd-text:01  spacing:bottom:24">家計の状況に合わせて、毎月の返済額を自由に設定できます。給料日やまとまった資金が手に入るタイミングなど、あなたの都合の良い日を返済日に設定できるので、安心して利用できます。</p>
    <ul class="owd-list:annotation">
      <li>随時返済や月々の返済日・返済額の見直しも可能です。</li>
      <li>ローンの取引は代表口座を利用して行います。</li>
    </ul>
  </section>
  <section class="owd-section spacing:bottom:64">
    <h2 class="owd-heading:03 align:center spacing:bottom:40">利用までの流れ</h2>
    <div class="spacing:bottom:40">
      <div class="owd-section-header spacing:bottom:40">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 01</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">定額返済をタップ</h2>
        <p class="owd-text:01 spacing:bottom:24">Banking画面内の「ローン」タブを選択後、「Loan」内の「定額返済」をタップします。</p>
        <div class="owd-img-area">
          <img src={img_step01} width="310" height="174" alt="定額返済をタップ">
        </div>
      </div>
      <div class="owd-section-header spacing:bottom:40">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 02</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">返済日・返済額を設定</h2>
        <p class="owd-text:01 spacing:bottom:24">毎月の返済日を設定後、返済額を入力します。</p>
        <div class="owd-img-area">
          <img src={img_step02} width="310" height="174" alt="返済日・返済額を設定">
        </div>
      </div>
      <div class="owd-section-header">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 03</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">定額返済内容を確認</h2>
        <p class="owd-text:01 spacing:bottom:24">返済完了予定月や返済額などを確認のうえ、「確定する」を押下すれば完了です。</p>
        <div class="owd-img-area">
          <img src={img_step03} width="310" height="174" alt="定額返済内容を確認">
        </div>
      </div>
    </div>
    <div class="show:sp">
      <div class="block:center spacing:bottom:16">
        <a href="https://minna-no-ginko.go.link/?tp=pg&pg=bl&adj_t=1t72r13o" class="owd-button owd-button:large owd-button:primary">アプリで確認する</a>
      </div>
      <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
  </section>
